import { styled } from 'style'

const AvatarStyled = styled('span', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '$round',
  truncate: true,

  variants: {
    size: {
      xs: {
        size: '$4',
        fontSize: '$xs',
      },
      sm: {
        size: '$5',
        fontSize: '$xs',
      },
      md: {
        size: '$6',
        fontSize: '$xs',
      },
      lg: {
        size: '$8',
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
})

const FallbackStyled = styled('span', {
  size: '100%',
  borderRadius: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$bg3',
  color: '$text2',
  lineHeight: '$sm',
  maxWidth: '100%',
})

export const Root = AvatarStyled
export const Fallback = FallbackStyled
